import type { ContentObjectList, ContentObjectView, NonEventContentObjectDetail } from 'models';
import { getUserName } from 'models';
import { Divider, Flex } from 'ui';
import { CommentsWrapper } from '../../comments-wrapper';
import { ContentObjectModal } from '../../content-object-modal';
import { useContentObjectComments } from '../../hooks';
import { ContentObjectRendererComponent } from './content-object-renderer-component';

type P = {
  forceCommentsOpen?: boolean;
  item: ContentObjectList | NonEventContentObjectDetail;
  view: ContentObjectView;
};

const ContentObjectRenderer = ({ forceCommentsOpen, item, view }: P) => {
  const {
    commentContentObject,
    commentFormContainerRef,
    editorRef,
    inputRef,
    isCommentable,
    isModalOpened,
    onCloseModal,
    onShowComments,
  } = useContentObjectComments({ forceCommentsOpen, item });

  const isInlineCommentsVisible = Boolean(forceCommentsOpen && isCommentable && commentContentObject);

  return (
    <>
      <Flex gap="medium" vertical>
        <ContentObjectRendererComponent item={item} onShowComments={onShowComments} view={view} />
        {isInlineCommentsVisible && commentContentObject ? (
          <>
            <Divider marginNone />
            <CommentsWrapper
              commentFormContainerRef={commentFormContainerRef}
              contentObject={commentContentObject}
              editorRef={editorRef}
              inputRef={inputRef}
            />
          </>
        ) : null}
      </Flex>

      {commentContentObject && !isInlineCommentsVisible ? (
        <ContentObjectModal
          commentFormContainerRef={commentFormContainerRef}
          contentObject={commentContentObject}
          contentObjectRenderer={
            <ContentObjectRendererComponent item={item} onShowComments={onShowComments} view={view} />
          }
          editorRef={editorRef}
          inputRef={inputRef}
          isOpened={isModalOpened}
          onClose={onCloseModal}
          title={getUserName(item.author)}
        />
      ) : null}
    </>
  );
};

export default ContentObjectRenderer;
